import { Component, EventEmitter, OnInit, Output, ViewEncapsulation, ɵɵtrustConstantResourceUrl } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { columnsDef } from 'src/app/interfaces/columnsDef';
import { JsonFormsNewComponent } from 'src/app/json-editor-module/json-forms-new-popup/json-forms-new/json-forms-new.component';
import { DialogService } from 'src/app/services/dialog.service';
import { DynamicFormsService } from 'src/app/services/dynamic-forms.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { JsonFormsPopupComponent } from 'src/app/system-utils/json-forms-popup/json-forms-popup.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';


@Component({
    selector: 'app-form-view-text',
    templateUrl: './form-view-text.component.html',
    styleUrls: ['./form-view-text.component.scss'],
    standalone: false
})
export class FormViewTextComponent implements OnInit {

  showBuscaDados:boolean = true;
  config:columnsDef;
  group: UntypedFormGroup;
  entityName:string;
  entityDesc:string;
  row:Object;
  pk:Object;
  @Output() editEvent:EventEmitter<boolean> = new EventEmitter();
  tabindex:string;
  canConfig:boolean = false;
  toolTipText = null;
  constructor(public dynaServices:DynamicFormsService, private dialog:DialogService, private http:HTTPService, private snackServices:SnackbarService) {  }

  ngOnInit() {
    
  }

  ngAfterViewInit(){
  }

  @Output() blurEvent:EventEmitter<boolean> = new EventEmitter();
  bluring(event){
      this.blurEvent.next(event)
  }
  
  editing(){
    this.editEvent.next(true)
  }

  saveData(data){
      
      var backupColumn = this.config.COLUMNNAME+"_ORIGINAL";
      var column:string = this.config.COLUMNNAME;
      if ( Object.keys(this.row).indexOf(backupColumn)>-1){

        
        var parserdJson:Object = data;
        
        this.group.get(column).patchValue(JSON.stringify(parserdJson[column]))

        if ( !ObjectUtil.isNotEmpty(this.row[backupColumn])){
          this.group.get(backupColumn).patchValue(this.row[column])
        }
        
        
        this.editEvent.next(true);


      }else{
        this.snackServices.showError("Não é permitido alterar esse campo.");
      }
  }

  openJSONPopUp(value){

        if ( ObjectUtil.isNotEmpty(value)  ){  
          try{
            
            if( (value as string).startsWith('{') || (value as string).startsWith('[')){
              let ob = JSON.parse(value); 
            
              let data = {
                            json: value,
                            json_original: this.row[this.config.COLUMNNAME+'_ORIGINAL'],
                            main: this.config.COLUMNDESC
              }
              this.dialog.openGenericDialog(JsonFormsNewComponent,data,(values)=>{
                this.saveData(values);
              },()=>{
              },'95%','100vw',true,null,'S','10px');
            }else{
              this.group.get(this.config.COLUMNNAME).enable();
            }
          }catch( Exception){
            this.group.get(this.config.COLUMNNAME).enable();
          }
        }else{
            this.group.get(this.config.COLUMNNAME).enable();
        }
      
      
  }
}
